import { Dispatch } from 'redux';

import { toggleStreamWarningMsg } from '@/redux/actions';
import { DailyCreditType, UserState } from '@/redux/slices/user/types';
import { trackMP } from '@/shared/mp';

let timeoutId: ReturnType<typeof setTimeout> | null = null;

const showMessage = (creditType: DailyCreditType, dailyCredits: UserState['dailyCredits'], dispatch: Dispatch) => {
  if (!dailyCredits?.inUse) {
    return;
  }
  const messages: Record<DailyCreditType, string> = {
    cameraMovement: "Upgrade for unlimited Move. Today's limit reached!",
    cameraZoom: "Upgrade for unlimited Zoom. Today's limit reached!",
    captureClip: "Upgrade for unlimited Clips. Today's limit reached!",
    capturePhoto: "Upgrade for unlimited Photos. Today's limit reached!",
  };
  if (dailyCredits[creditType] === 0) {
    dispatch(toggleStreamWarningMsg(messages[creditType]));
    trackMP('hit-daily-credit-limit', { creditType });
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => dispatch(toggleStreamWarningMsg(false)), 5000);
  }
};

export const cameraMovementCreditCheckMessage = (dailyCredits: UserState['dailyCredits'], dispatch: Dispatch) =>
  showMessage('cameraMovement', dailyCredits, dispatch);
export const cameraZoomCreditCheckMessage = (dailyCredits: UserState['dailyCredits'], dispatch: Dispatch) =>
  showMessage('cameraZoom', dailyCredits, dispatch);
export const captureClipCreditCheckMessage = (dailyCredits: UserState['dailyCredits'], dispatch: Dispatch) =>
  showMessage('captureClip', dailyCredits, dispatch);
export const capturePhotoCreditCheckMessage = (dailyCredits: UserState['dailyCredits'], dispatch: Dispatch) =>
  showMessage('capturePhoto', dailyCredits, dispatch);
